
export enum BasketItemType
{
    Unset = "Unset",
    Rent = "Rent",
    Sale = "Sale"
}
